import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeglass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 27,
	viewBox: "0 0 20 27",
	...props,
	children: /* @__PURE__ */ _jsx("text", {
		id: "_",
		"data-name": "\\u23F3",
		transform: "translate(10 18)",
		fill: "#032478",
		fontSize: 14,
		fontFamily: "AppleColorEmoji, Apple Color Emoji",
		children: /* @__PURE__ */ _jsx("tspan", {
			x: -9.5,
			y: 0,
			children: "⏳"
		})
	})
});
export default SvgTimeglass;
